import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-beveled-picture',
  templateUrl: './beveled-picture.component.html',
  styleUrls: ['./beveled-picture.component.scss'],
})
export class BeveledPictureComponent {
  @Input() public src: string;

  public get cssStyle(): object {
    return {
      'background-image': `url(${this.src})`,
    };
  }
}
